import { cn } from "@/lib/utils";
import * as shared from "@/styles/shared";

const container = cn("relative isolate overflow-hidden", shared.page);

const statsGrid = "mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4";

const pageEnter = "page-enter";

const skeletonCard = cn("rounded-lg bg-muted p-3", shared.rowGap3);

const skeletonIcon = "h-9 w-9 rounded-lg bg-muted/80 shrink-0";

const skeletonText = "h-3 w-20 rounded bg-muted/80";

const skeletonValue = "h-5 w-24 rounded bg-muted/80 mt-1";

const comboSection = "mt-8";

const comboHeader = cn(shared.rowGap2, "mb-4");

const comboIcon = cn(shared.iconSm, shared.iconMuted);

const comboTitle = cn(shared.titleSmSemibold, "tracking-tight");

const comboEmpty = cn(shared.colCenter, "py-8 text-muted-foreground");

const comboEmptyIcon = "h-6 w-6 text-muted-foreground/50";

const comboEmptyText = "text-sm font-medium text-foreground mt-1";

const comboEmptyHint = "text-xs text-muted-foreground mt-1 max-w-sm";

const comboEmptyAction =
  "mt-3 inline-flex items-center gap-1.5 rounded-md bg-primary px-3 py-1.5 text-xs font-medium text-primary-foreground hover:bg-primary/90 transition-colors";

const comboGrid = "grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-3";

const statCardWrapper = cn(
  "relative overflow-hidden rounded-xl border border-border bg-card p-4",
  shared.transitionDefault,
  "hover:border-primary/25",
);

const statIconWrapper = "flex h-10 w-10 shrink-0 items-center justify-center rounded-lg";

const statInfo = "min-w-0 flex-1";

const statLabel = "truncate text-xs font-medium text-muted-foreground";

const statValue = "truncate text-lg font-bold tracking-tight";

export {
  container,
  statsGrid,
  pageEnter,
  skeletonCard,
  skeletonIcon,
  skeletonText,
  skeletonValue,
  comboSection,
  comboHeader,
  comboIcon,
  comboTitle,
  comboEmpty,
  comboEmptyIcon,
  comboEmptyText,
  comboEmptyHint,
  comboEmptyAction,
  comboGrid,
  statCardWrapper,
  statIconWrapper,
  statInfo,
  statLabel,
  statValue,
};
